import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isPostalCode from 'validator/lib/isPostalCode';
import {FULLNAME_PATTERN} from '../upi/constants';

const messages = {
    required: '{alias} is required',
    fullName: 'Please enter a valid first and last name',
    email: 'Please enter a valid email address',
    phoneNumber: 'Please enter a valid phone number',
    postalCode: 'Please enter a valid postal code'
};

export default function Validator ( schema ) {
    this.schema = schema;
}

Validator.prototype.validate = function validate ( obj ) {
    const errors = {};
    const schema = this.schema;
    // const fields = Object.keys( obj );
    Object.entries( obj ).forEach( ent => {
        const fieldName = ent[0];
        const val = ent[1];
        const fieldSchema = schema[fieldName];
        const {fullName, email, phoneNumber, postalCode, required, alias} = fieldSchema;

        // todo -> check if required, if not only validate if not empty
        if ( !!fullName && !FULLNAME_PATTERN.test( val ) ) {
            errors[fieldName] = fullName.message || messages.fullName;
        }

        if ( !!email && !isEmail( val ) ) {
            errors[fieldName] = email.message || messages.email;
        }

        if ( !!phoneNumber && !isMobilePhone( val, phoneNumber.locale || 'en-US' ) ) {
            errors[fieldName] = phoneNumber.message || messages.phoneNumber;
        }

        if ( !!postalCode && !isPostalCode( val, postalCode.locale || 'US' ) ) {
            errors[fieldName] = postalCode.message || messages.postalCode;
        }

        if ( !!required && isEmpty( val ) ) {
            let msg = required.message || messages.required;
            errors[fieldName] = msg.replace( '{alias}', alias || 'This field' );
        }
    } );

    return errors;
};